import parseToFloat from "../../../../components/texts/parseToFloat";

export const getBalancedData = async (existingData: any[], apiData: any[]) => {
  const updatedData = existingData.map(item => {
    // Find matching entry in the API data
    const matchingApiEntry = Object.values(apiData).find(apiItem =>
        apiItem.id === item.id
    );

    if (matchingApiEntry) {
      const itemCopy = { ...item };

      // Subtract the allocated quantity from the available quantity
      itemCopy.available_quantity -= parseToFloat(matchingApiEntry.allocated_quantity);

      return itemCopy;
    }

    return item;
  });

  return updatedData;
};

export const getMappedData = (existingData: any[], apiData: any[]) => {
  const updatedData = existingData.map(item => {
    // @ts-ignore
    const matchingApiEntry = Object.values(apiData).find(apiItem => apiItem.biotemplate_id === String(item.id)
    );

    if (matchingApiEntry) {
      // Update the allocated_quantity
      // @ts-ignore
      return { ...item, allocated_quantity: matchingApiEntry.allocated_quantity };
    }

    return item;
  });

  return updatedData;
};

export function isNonEmptyArrayOrObject(value: any): boolean {
  if (Array.isArray(value)) {
    return value.length > 0;
  }

  if (typeof value === "object" && value !== null) {
    return Object.keys(value).length > 0;
  }

  return false;
}
